module.exports = __webpack_public_path__ + "img/dev-heroes-2.954ea1d4.webp";